<template>
	<v-container grid-list-md>
		<v-card>
			<v-card-title primary-title>
				<v-btn
					icon
					@click="
						$inertia.visit(
							$route(
								'central.pushnotifications.index',
								$page.props
							)
						)
					"
					><v-icon>mdi-arrow-left</v-icon></v-btn
				>{{ $t("title.edit_push_notification") }}
			</v-card-title>
			<v-card-text>
				<form-push-notification v-model="item"></form-push-notification>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					color="primary"
					@click.native="submit()"
					:loading="item.processing"
				>
					<v-icon left>mdi-content-save</v-icon>
					{{ $t("Update") }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-container>
</template>
<script>
import FormPushNotification from "@App/forms/FormPushNotification.vue";
export default {
	components: { FormPushNotification },
	props: ["data"],
	data() {
		return {
			item: this.$inertia.form(this.data),
		};
	},
	methods: {
		submit() {
			this.item.put(
				this.$route("central.pushnotifications.update", this.item.uuid)
			);
		},
	},
};
</script>